import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Environment, isDesktopApp } from '../../../../submodules/engine-common/environment-util';
import { environment as angularCliEnvironment } from '../../../environments/environment';

/**
 * Contiene le variabili d'ambiente caricate da file esterno o, se l'applicazione è stata lanciata con "ng serve", da file interno.
 */
@Injectable()
export class EnvironmentDataService {
  
  public environment: Environment;

  //True se l'app è servita da express; False se è servita da angular CLI. Valorizzata solo in caso di Web App,
  public isServedByExpress;

  //Puntatore al Renderer Process, valorizzato solo in caso di Electron App, necessario per mandare eventi verso il Main Process
  public ipcRenderer;

  //Informazioni relative alla specifica istanza di al Renderer Process, valorizzato solo in caso di Electron App
  public windowInfo;

  constructor(
    private _httpClient: HttpClient) 
  { 
    if (isDesktopApp())
      this.ipcRenderer = window['require']('electron').ipcRenderer;
  }  

  /**
   * Carica le environment variables.
   * Se l'applicazione è di tipo Desktop
   *   -> Richiede al main process di caricarle e di ritornarle al render
   * Se invece l'applicazione è di tipo Web
   *   -> Se l'applicazione è stata lanciata con "ng serve"
   *        -> Recupera le config da environment di sviluppo
   *      Altrimenti 
   *        -> Recupera le config dal file environment esterno. 
   */
  public load = async () => {
    
    let _environmentVariables;
    
    if (isDesktopApp()) {
      console.log('Desktop App');

      //Richiede le environment variables al MAIN process
      _environmentVariables = this.ipcRenderer.sendSync('GET_ENVIRONMENT_VARIABLES');

      this.environment = new Environment(_environmentVariables);
      
      this.windowInfo = this.ipcRenderer.sendSync('GET_WINDOW_INFO');

    } else { //Web app
      console.log('Web App');

      this.isServedByExpress = true;
      let isServedByFirebase = false;
      try{
        _environmentVariables = await this._httpClient.get("/conf/environment.json").toPromise();
      }catch(e){
         //Assume che l'app sia stata lanciata con "ng serve"
         this.isServedByExpress=false;
         _environmentVariables = angularCliEnvironment.config;

         if(!_environmentVariables){
            isServedByFirebase = true;
            //Assume che le environment variables siano state caricate nella
            //nuova maniera:
            // Read environment variables from browser window
            const browserWindow = window || {};
            const browserWindowEnv = browserWindow['__env'] || {};
            _environmentVariables = browserWindowEnv.config
         }
      }

      this.environment = new Environment(_environmentVariables);
      
      if(isServedByFirebase)
        console.log(`Web App served via Firebase`);
      else
        console.log(`Web App served via ${this.isServedByExpress?'Express':'Angular CLI'}`);
    }

    console.log('environment :', _environmentVariables);
  }
}
